export const appendToListSubQueryCache = (
  cache,
  listFieldParentId,
  listFieldParentTypeName,
  listFieldName,
  newRecord,
  insertIndex = null
) => {
  cache.modify({
    id: cache.identify({
      id: listFieldParentId,
      __typename: listFieldParentTypeName,
    }),
    fields: {
      [listFieldName](existingList, { toReference, readField }) {
        const oldIndex = existingList.findIndex(
          (item) => readField('id', item) === newRecord.id
        );
        const newList = [...existingList];
        if (oldIndex >= 0) {
          newList.splice(oldIndex, 1);
        }
        if (insertIndex === null) {
          insertIndex = oldIndex >= 0 ? oldIndex : newList.length;
        }

        newList.splice(insertIndex, 0, toReference(newRecord));
        return newList;
      },
    },
  });
};

export const deleteFromListSubQueryCache = (
  cache,
  listFieldParentId,
  listFieldParentTypeName,
  listFieldName,
  recordId
) => {
  cache.modify({
    id: cache.identify({
      id: listFieldParentId,
      __typename: listFieldParentTypeName,
    }),
    fields: {
      [listFieldName](existingList, { readField }) {
        const index = existingList.findIndex(
          (item) => readField('id', item) === recordId
        );
        if (index >= 0) {
          const newList = [...existingList];
          newList.splice(index, 1);
          return newList;
        } else {
          return existingList;
        }
      },
    },
  });
};

export const deleteFromListSubQueryCacheWhere = (
  cache,
  listFieldParentId,
  listFieldParentTypeName,
  listFieldName,
  predicate
) => {
  cache.modify({
    id: cache.identify({
      id: listFieldParentId,
      __typename: listFieldParentTypeName,
    }),
    fields: {
      [listFieldName](existingList, { readField }) {
        const newList = existingList.filter((item) => {
          return !predicate({ item, readField });
        });
        return newList;
      },
    },
  });
};
